export const isFormattedEmail = (email: string) => {
  const regExp = /\S+@\S+\.\S+/;
  if (regExp.test(email)) {
    return true;
  }
  return false;
};
